import { createApiSlice } from "@common";
import {
  CRUD_PROSPECT_INTEREST,
  GET_PROSPECT_INTEREST_BY_PROSPECT_ID
} from "@routes";

const apiConfig = [
  {
    name: "addProspectInterest",
    method: "post",
    url: CRUD_PROSPECT_INTEREST,
    stateKey: "message",
  },
  {
    name: "getProspectInterestByProspectId",
    method: "get",
    url: GET_PROSPECT_INTEREST_BY_PROSPECT_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "prospectInterest",
  apiConfig,
  customReducers,
);
const prospectInterestSlice = slice;

export default prospectInterestSlice.reducer;

export const {
  addProspectInterest,
  getProspectInterestByProspectId,
} = thunks;

export const { rowSelect } = actions;
